import { render } from "./CustomThankYou.vue?vue&type=template&id=374ca380&scoped=true&ts=true"
import script from "./CustomThankYou.vue?vue&type=script&lang=ts"
export * from "./CustomThankYou.vue?vue&type=script&lang=ts"

import "./CustomThankYou.vue?vue&type=style&index=0&id=374ca380&scoped=true&lang=css"

import exportComponent from "/home/newbuyanyinsuran/public_html/wizards/car.buyanyinsurance.ae/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374ca380"]])

export default __exports__